// extracted by mini-css-extract-plugin
module.exports = {"wrap":"G1av","imgBg":"G1abf","image":"G1ob","textBox":"G1abh","labels":"G1abl","title":"G1al","statistic":"G1a5","advLabel":"G1kh"};